module.exports = __webpack_public_path__ + "img/Online restaurants Icon - charcoal.54ee3e6d.svg";